const BASE = '/settings/moderation' as const

export const moderationRoutes = {
  root: BASE,
  space: (spaceId: string) => `${BASE}/${spaceId}`,
} as const
